<template>
    <div v-if="rootHeaderMenuItems.length > 0"  class="main-menu">
        <router-link :to="getMenuRoute(menuItem)"
            class="main-menu-item" v-for="menuItem in rootHeaderMenuItems" v-bind:key="menuItem.id">{{ menuItem.title }} </router-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters([
            "rootHeaderMenuItems",
            "fiaInsightsRoot",
        ]),
    },
    methods: {
        getMenuRoute(menuItem) {
            if (menuItem.slug === 'fia-intelligence' && this.fiaInsightsRoot) {
                return { name: 'fiaIntelligenceDetails', params: { id: this.fiaInsightsRoot.id, slug: this.fiaInsightsRoot.slug } };
            }
            return { name: 'menuDetailsNew', params: { id: menuItem.id, slug: menuItem.slug } };
        }
    }
}
</script>

<style scoped>
.main-menu {
    /* font-size: 24px;
    line-height: 30px; */
    font-size: 1.3rem;
    line-height: 1.4rem;
    font-weight: 500;
    /* padding: 55px 5% 0% 5%; */
    padding: 30px 5% 0% 5%;
    width: 55%;
    display: flex;
    text-align: center;
    gap: 25px;
}

.main-menu-item {
    color: var(--main-color);
    display: flex;
    align-items: end;
}

@media only screen and (max-width: 1400px) {
    .main-menu{
        gap: 15px;
    }
}
</style>
